$(document).ready(function(){
  $(".quick-add").after(" <p class='view-btn-cus'> VIEW PRODUCT </button> ");
  $(".hide-filter-btn").click(function(){
    $(".facets-wrapper").toggleClass("hide-filter-jq");
    $(".product-grid").toggleClass("grid-col-4cus");
     // Toggle the text based on the active class
    var filterText = $(".hide-filter-btn").text();
    if ($(".facets-wrapper").hasClass("hide-filter-jq")) {
      $(".hide-filter-btn").text("Show Filter");
    } else {
      $(".hide-filter-btn").text("Hide Filter");
    }
  });

setTimeout(function() {
  jQuery("#product-grid > li").each(function() {
    console.log("link working");
    var link = jQuery(this).find(".full-unstyled-link").attr("href");
    jQuery(".view-btn-cus").attr("href", link)
    console.log(link);
  });
}, 1500); // 1500 milliseconds = 1.5 seconds
  
  });

// Calculator jQuery Start

jQuery(document).ready(function () {
    console.log("ready");

       $(document).ready(function () {
            function calculateLoan() {
                var vehiclePrice = parseFloat($(".vehicle-price-input").val());
                var interestRate = parseFloat($(".interest-rate-input").val()) / 100; // Convert to decimal
                var months = parseFloat($(".month-input").val());
                var downPayment = parseFloat($(".downpayment-input").val());

                // Calculate the loan amount
                var loanAmount = vehiclePrice - downPayment;

                // Calculate monthly interest rate
                var monthlyInterestRate = interestRate / 12;

                // Calculate monthly payment
                var monthlyPayment = (loanAmount * monthlyInterestRate) / (1 - Math.pow(1 + monthlyInterestRate, -months));

              var totalInterest = (monthlyPayment * months) - loanAmount;
              var totalAmount = totalInterest + loanAmount + downPayment;

              $(".mp-value").text(monthlyPayment.toFixed(2));
              $(".ip-value").text(totalInterest .toFixed(2));
              $(".ta-value").text(totalAmount.toFixed(2));

              

                $("#monthly-payment").text(monthlyPayment.toFixed(2));
              console.log(monthlyPayment);
              console.log(totalInterest);
              console.log(totalAmount);

              
            }

            $(".submit-btn").click(function () {
                calculateLoan();
            });
        });
});

                  

// Calculator jQuery Ends



// 

jQuery(document).ready(function () {
    $(".submit-btn").click(function () {
        $(".value-box-wrap").css("display", "block");
    });
});
// 


